import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

const placesSearchSchema = z
  .object({
    cityId: z.uuid().optional(),
  })
  .catch({});

export type PlacesSearch = z.infer<typeof placesSearchSchema>;

export const Route = createFileRoute('/_authenticated/places')({
  staticData: { breadcrumb: 'Места' },
  validateSearch: placesSearchSchema,
  component: () => <Outlet />,
});
